import { getAttachmentsTokens } from '../utils/getAttachmentsTokens';
export function prepareAttachmentsTokens(formValue) {
  /** Здесь добавляются attachmentsTokens - токены загруженных файлов, которые прикрепляются к обращению пользователя.
   *  По умолчанию они берутся из поля files, однако не для всех флоу реализована загрузка файлов
   *  и не ко всем обращениям нужно что-либо прикреплять.
   *  В некоторых кейсах токены загруженных файлов должны быть прикреплены из другого поля или другого набора полей,
   *  например не из files, а passportPhotos или что-то в этом роде.
   *  Для этих целей предназначен switch, в котором мы указываем источник для сбора токенов для конкретной темы обращения.
   */

  return getAttachmentsTokens(formValue.files);
}